import type { ReactNode } from 'react'
import { X } from 'lucide-react'

const pillClassName =
    'inline-flex max-w-full items-center gap-1.5 rounded-md border border-border bg-muted px-2 py-1 text-xs text-foreground'

export function RemovablePill({
    icon,
    imageUrl,
    imageAlt,
    label,
    ariaLabel,
    onRemove,
}: {
    icon?: ReactNode
    imageUrl?: string | null
    imageAlt?: string
    label: string
    ariaLabel: string
    onRemove: () => void
}) {
    return (
        <span className={pillClassName}>
            {imageUrl ? (
                <span className="relative size-4 shrink-0 overflow-hidden rounded-full">
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                        src={imageUrl}
                        alt={imageAlt ?? ''}
                        className="size-full object-cover"
                    />
                </span>
            ) : icon ? (
                icon
            ) : null}
            <span className="truncate">{label}</span>
            <button
                type="button"
                aria-label={ariaLabel}
                className="hover:bg-muted-foreground/15 ml-0.5 flex size-4 shrink-0 items-center justify-center rounded-full text-muted-foreground hover:text-foreground"
                onClick={onRemove}
            >
                <X size={10} />
            </button>
        </span>
    )
}
